import angular from 'angular'

import selectTicketFieldConfig from './directive/selectTicket/fieldConfig'
import inforConfirmFieldConfig from './directive/inforConfirm/fieldConfig'
const listPage = require('./view/list.html')
const addPage = require('./view/addRedFrom.html')
const detailPage = require('./view/detail.html')
const listCtrl = require('./list')
const addRedFromCtrl = require('./addRedFrom')
const billTemplateModal = require('./directive/selectTicket/billTemplateModal')
const synchronousModal = require('./directive/selectTicket/synchronousModal')
const detailCtrl = require('./detail')
const downloadCtrl = require('./downloadCtrl')
const confirmPage = require('./view/confirm.html')
const confirmCtrl = require('./confirmCtrl')
const invoicePage = require('./view/invoicing.html')
const invoiceCtrl = require('./invoicingCtrl')
const redInkConfirmFormChooseUkeyModal = require('./redInkConfirmFormChooseUkeyModal')
const warnModal = require('./warnModal')
const allEleInvRedTemplateCtr = require('./allEleInvRedTemplateCtr')
const sendEmailCtrl = require('./sendEmailCtrl')

import selectTicket from './directive/selectTicket/selectTicket'
import inforConfirm from './directive/inforConfirm/inforConfirm'
import submitSuccess from './directive/submitSuccess/submitSuccess'

function configRouter($stateProvider) {
    $stateProvider.state('outputManage.fullElectricInvoice.redInkConfirmForm', {
        url: '/redInkConfirmForm',
        abstract: true,
        template: '<div ui-view></div>',
        default: 'outputManage.fullElectricInvoice.redInkConfirmForm.list',
        title: '红字确认单',
    })
    $stateProvider.state('outputManage.fullElectricInvoice.redInkConfirmForm.list', {
        url: '/list',
        template: listPage,
        controller: 'redInkConfirmFormListCtrl',
    })
    $stateProvider.state('outputManage.fullElectricInvoice.redInkConfirmForm.add', {
        url: '/add/:currentTab/:confirmId',
        template: addPage,
        controller: 'addRedFromCtrl',
        title: '新增红字确认单',
    })
    $stateProvider.state('outputManage.fullElectricInvoice.redInkConfirmForm.confirm', {
        url: '/confirm/:confirmIds/:total/:type/:ukeyId',
        template: confirmPage,
        controller: 'redInkConfirmFormConfirmCtrl',
        title: '红字发票确认信息处理',
    })
    $stateProvider.state('outputManage.fullElectricInvoice.redInkConfirmForm.detail', {
        url: '/detail/:confirmId',
        template: detailPage,
        controller: 'redInkConfirmFormDetailCtrl',
        title: '详情',
    })
    $stateProvider.state('outputManage.fullElectricInvoice.redInkConfirmForm.invoice', {
        url: '/invoice/:confirmIds/:total/:type/:ukeyId',
        template: invoicePage,
        controller: 'redInkConfirmFormInvoiceCtrl',
        title: '红字发票开具',
    })
}

export default angular
    .module('outputManage.fullElectricInvoice.redInkConfirmForm', [])
    .config(['$stateProvider', configRouter])
    .value('STFieldConfig', selectTicketFieldConfig)
    .value('inforConfirmFieldConfig', inforConfirmFieldConfig)
    .directive('selectTicketsTab', selectTicket)
    .directive('inforConfirmTab', inforConfirm)
    .directive('submitSuccessTab', submitSuccess)
    .controller('redInkConfirmFormListCtrl', listCtrl.default)
    .controller('redInkConfirmFormDetailCtrl', detailCtrl.default)
    .controller('redInkConfirmFormDownloadCtrl', downloadCtrl.default)
    .controller('redInkConfirmFormConfirmCtrl', confirmCtrl.default)
    .controller('redInkConfirmFormInvoiceCtrl', invoiceCtrl.default)
    .controller('sendEmailCtrl', sendEmailCtrl.default)
    .controller('addRedFromCtrl', addRedFromCtrl.default)
    .controller('billTemplateModal', billTemplateModal.default)
    .controller('redInkConfirmFormChooseUkeyModal', redInkConfirmFormChooseUkeyModal.default)
    .controller('warnModal', warnModal.default)
    .controller('allEleInvRedTemplateCtr', allEleInvRedTemplateCtr.default)
    .controller('synchronousModal', synchronousModal.default).name



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/redInkConfirmForm/index.js